import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { compressImageFile } from "../lib/imageCompression";

// Captura/upload de fotos como evidência de um item do checklist.
// Armazena como data URLs (base64) já comprimidas (ver imageCompression.js)
// para funcionar 100% no front-end sem backend de upload, mas sem pesar o
// banco com fotos de câmera em alta resolução.
export default function PhotoUpload({ fotos, onChange, max }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [processando, setProcessando] = useState(false);
  const atingiuLimite = typeof max === "number" && fotos.length >= max;

  async function handleFiles(e) {
    const files = Array.from(e.target.files || []);
    const restante = typeof max === "number" ? Math.max(0, max - fotos.length) : files.length;
    const selecionados = files.slice(0, restante);
    e.target.value = "";
    if (selecionados.length === 0) return;
    setProcessando(true);
    const novas = [];
    for (const file of selecionados) {
      try {
        novas.push(await compressImageFile(file));
      } catch (err) {
        console.error("Falha ao comprimir foto:", err);
      }
    }
    setProcessando(false);
    if (novas.length > 0) onChange([...fotos, ...novas]);
  }

  function removeFoto(index) {
    onChange(fotos.filter((_, i) => i !== index));
  }

  return (
    <div className="photo-upload">
      <div className="photo-upload__thumbs">
        {fotos.map((foto, i) => (
          <div className="photo-upload__thumb" key={i}>
            <img src={foto} alt={`evidência ${i + 1}`} />
            <button
              type="button"
              className="photo-upload__remove"
              onClick={() => removeFoto(i)}
              aria-label={t("checklist.photo_remove_aria")}
            >
              ×
            </button>
          </div>
        ))}
        {!atingiuLimite && (
          <button
            type="button"
            className="photo-upload__add"
            onClick={() => inputRef.current?.click()}
            disabled={processando}
          >
            {processando ? "..." : t("checklist.photo_add")}
          </button>
        )}
      </div>
      {typeof max === "number" && (
        <p className="hint" style={{ marginTop: 4, fontSize: 12 }}>
          {t("checklist.photo_count", { count: fotos.length, max })}
        </p>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        capture="environment"
        style={{ display: "none" }}
        onChange={handleFiles}
      />
    </div>
  );
}
